import { PropsWithChildren } from 'react'
import clsx from 'clsx'

import styles from './PopoverPanel.module.scss'

type PopoverPanelProps = PropsWithChildren<{
  id?: string
  /** Which edge of the trigger the panel lines up with */
  align?: 'start' | 'end'
  className?: string
}>

/** The surface of a menu or picker that opens below a button */
export default function PopoverPanel({
  id,
  align = 'end',
  className,
  children,
}: PopoverPanelProps) {
  return (
    <div
      id={id}
      className={clsx(
        styles.panel,
        { [styles.alignStart]: align === 'start' },
        className,
      )}
    >
      {children}
    </div>
  )
}
